/** Function that sorts arrays or Float64Arrays in descending order
 *
 * @param array - array to sort
 * @returns sorted array
 */
export function xSortDescending(array) {
    if (ArrayBuffer.isView(array)) {
        return array.sort().reverse();
    }
    else if (Array.isArray(array)) {
        return array.sort((a, b) => b - a);
    }
    throw new Error('trying to sort non array');
}
//# sourceMappingURL=xSortDescending.js.map